import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail } from 'lucide-react';
import './ContactSection.css';

const ContactSection = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    setTimeout(() => setFormSubmitted(false), 3000); // Reset after 3s
  };

  const handleMapClick = () => {
    window.open('https://maps.google.com?q=12+Waghorn+Road,+London,+E13+9JQ', '_blank');
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <motion.h2
          className="contact-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          Contact VBC Services LTD
        </motion.h2>
        <div className="contact-row">
          <motion.div
            className="contact-info-col"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h3 className="contact-subtitle">Get in Touch</h3>
            <div className="contact-info-card">
              <motion.div className="contact-info-item" whileHover={{ scale: 1.05 }}>
                <MapPin className="contact-icon" size={24} />
                <span>12 Waghorn Road, London, E13 9JQ, UK</span>
              </motion.div>
              <motion.div className="contact-info-item" whileHover={{ scale: 1.05 }}>
                <Phone className="contact-icon" size={24} />
                <span>+44 7304 244778</span>
              </motion.div>
              <motion.div className="contact-info-item" whileHover={{ scale: 1.05 }}>
                <Mail className="contact-icon" size={24} />
                <span>vairagchaudhary98@gmail.com</span>
              </motion.div>
              <motion.div
                className="map-hotspot"
                onClick={handleMapClick}
                whileHover={{ scale: 1.02 }}
                transition={{ type: 'spring', stiffness: 300 }}
              />
            </div>
          </motion.div>
          <motion.div
            className="contact-form-col"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <h3 className="contact-subtitle">Send a Message</h3>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name" className="form-label">Your Name</label>
                <input type="text" className="form-input" id="name" placeholder="e.g., John Smith" required />
              </div>
              <div className="form-group">
                <label htmlFor="email" className="form-label">Your Email</label>
                <input type="email" className="form-input" id="email" placeholder="e.g., john@business.com" required />
              </div>
              <div className="form-group">
                <label htmlFor="message" className="form-label">Your Enquiry</label>
                <textarea className="form-input form-textarea" id="message" placeholder="Interested in bulk wholesale deals..." required />
              </div>
              <motion.button
                type="submit"
                className="contact-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Submit Enquiry
              </motion.button>
              {formSubmitted && (
                <motion.p
                  className="form-success"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  Enquiry sent! We’ll get back to you soon.
                </motion.p>
              )}
            </form>
            <div className="chat-teaser">
              <p>Need bulk order assistance now?</p>
              <motion.a
                href="#chat"
                className="chat-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Start Chat
              </motion.a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;